var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5431 22.5685C17.8407 22.2708 17.8407 21.7871 17.5431 21.4894L8.03609 12.001L17.5431 2.49407C17.8407 2.19639 17.8407 1.71267 17.5431 1.415C17.2454 1.11732 16.7617 1.11732 16.464 1.415L6.43608 11.4429C6.28725 11.5917 6.21283 11.7778 6.21283 11.9824C6.21283 12.1685 6.28725 12.3731 6.43608 12.522L16.464 22.5499C16.7617 22.8662 17.2454 22.8662 17.5431 22.5685Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.310a4a6c32cfdf90d2b204997c11cded.svg";
export { ForwardRef as ReactComponent };